module.exports = __webpack_public_path__ + "img/contact.60443939.svg";